var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSilverFrame = function SvgSilverFrame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#silverFrame_svg__a)",
    fillRule: "evenodd",
    d: "M33.5.776a3 3 0 0 0-3 0L5.787 15.044a3 3 0 0 0-1.5 2.598v28.536a3 3 0 0 0 1.5 2.598L30.5 63.044a3 3 0 0 0 3 0l24.713-14.268a3 3 0 0 0 1.5-2.598V17.642a3 3 0 0 0-1.5-2.598zm0 6.358a3 3 0 0 0-3 0L11.293 18.223a3 3 0 0 0-1.5 2.598v22.178a3 3 0 0 0 1.5 2.598L30.5 56.687a3 3 0 0 0 3 0l19.207-11.09a3 3 0 0 0 1.5-2.598V20.821a3 3 0 0 0-1.5-2.598z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "silverFrame_svg__a",
    x1: 32,
    x2: 32,
    y1: 0.652,
    y2: 62.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F5167"
  })))));
};
export default SvgSilverFrame;